import React from 'react';
import classnames from 'classnames';

import styles from './LabeledCard.module.scss';

export const LabeledCard = ({
  icon,
  id,
  title,
  vendorClass,
  headerAddition, children,
  centererd = false,
  small = false,
  header = false,
  none = false
}) => (
  <div
    data-testid={ id }
    className={ classnames(styles.card, vendorClass, centererd && styles.centered, small && styles.smallCard) }
  >
    {!none
    && (
      <div className={ !small ? styles.row : styles.smallRow }>
        {header
      ? header
: (
  <span className={ !small ? styles.title : styles.smallTitle }>
    {icon}
    <h2>
      {title}
    </h2>
  </span>
)}
        {headerAddition}

      </div>
)
    }
    <div>
      { children }
    </div>
  </div>
);

